import { alpha, Theme } from "@mui/material";
import { TreeItem } from "../../data/tree";
import { fontSize } from "@mui/system";

const useStyles = (theme: Theme) => ({
  innerButtonStyles: {
    // padding: "var(--grid)",
    // paddingRight: 10,

    padding: 12,
    alignItems: "center",
    display: "flex",
    width: "100%",
    flexDirection: "column" as const,
    //   background: token("color.background.neutral.subtle", "transparent"),
    borderRadius: 3,
  },
  innerDraggingStyles: { opacity: 0.4 },
  outerButtonStyles: (item: TreeItem) => ({
    "--grid": "8px",
    color: theme.palette.text.primary,
    border: "0",
    width: "100%",
    // width: "fit-content",
    position: "relative" as const,
    background: "transparent",
    margin: "0",
    padding: "0",
    borderRadius: "6px",
    cursor: "pointer",
    backgroundColor: item.children.length
      ? alpha(theme.palette.text.secondary, 0.1)
      : "transparent",
  }),
  parentOfInstructionStyles: {
    background: alpha(theme.palette.primary.main, 0.1),
  },
  outerStyles: {
    // needed for our action button that uses position:absolute
    position: "relative",
    // "--grid": "8px",
    width: "120px",
    // padding: 1,
    backgroundColor: alpha(theme.palette.text.secondary, 0.1),
    borderRadius: "6px",
    // margin: "3px 0 3px 0",
  },
  outerHoverStyles: {
    // borderRadius: "6px",
    // backgroundColor: "red",
    cursor: "pointer",
    "&:hover": {
      //   backgroundColor: "red",
      backgroundColor: alpha(theme.palette.text.secondary, 0.1),
    },
  },
  idStyles: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  debugStyles: {
    position: "absolute" as const,
    right: "var(--grid)",
    bottom: 0,
    fontSize: "10px",
  },
  labelStyles: (item: TreeItem) => ({
    maxWidth: "90px",
    color: theme.palette.text.secondary,
    // flexGrow: 1,
    overflow: "hidden",
    textAlign: "left" as const,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "0.875rem",
  }),
  labelExpiredDays: {
    maxWidth: "90px",
    color: theme.palette.error.main,
    // flexGrow: 1,
    overflow: "hidden",
    textAlign: "left" as const,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "0.875rem",
  },
  previewStyles: {
    // "--grid": "8px",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    padding: "12px",
    fontSize: "0.875rem",
    // padding: "var(--grid)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column" as const,
    borderRadius: 1.5,
  },
  iconOption: {
    color: theme.palette.text.secondary,
    fontSize: "1rem",
    position: "absolute",
    top: 0,
    right: 0,
  },
  icon: { color: theme.palette.text.secondary, m: 1 },
});

export default useStyles;
